import { AnyAction } from "redux";
import { AuthState } from "../../common/redux/AuthState";
import { LOADED_EXPERIMENTAL_FEATURES, LOCAL_LOGIN_START } from "./actions";
import { LOGOUT_SUCCESS, LOGIN_COMPLETE, UPDATE_SUBSCRIPTION_SUCCESS } from "../../common/redux/actions";

export const reducer = (
  state: AuthState = {
    user: null,
    loginStatus: "NOT_LOGGED_IN",
  },
  action: AnyAction
) => {
  switch (action.type) {
    case LOCAL_LOGIN_START:
      return { ...state, loginStatus: "LOGGING_IN" };
    case LOGIN_COMPLETE:
      const user = action.payload;
      return {
        ...state,
        user,
      };
    case LOGOUT_SUCCESS:
      return { ...state, user: null, loginStatus: "NOT_LOGGED_IN" };
    case UPDATE_SUBSCRIPTION_SUCCESS:
      const { subscribeToEmails } = action.payload;
      return {...state, user: {...state.user, subscribeToEmails }};
    case LOADED_EXPERIMENTAL_FEATURES:
      return {
        ...state,
        user: { ...state.user, experimentalFeatures: action.payload },
        loginStatus: "LOGGED_IN",
      };
    default:
      return state;
  }
};
